module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    class: _vm.classes
  }, [(_vm.showDot) ? _c('span', {
    class: _vm.dotClasses
  }) : _vm._e(), _c('span', {
    class: _vm.textClasses
  }, [_vm._t("default")], 2), (_vm.closable) ? _c('Icon', {
    attrs: {
      "type": "ios-close-empty"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.close($event)
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fde3ebe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/tag/tag.vue
// module id = 656
// module chunks = 1